import { useState } from "react";
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../shared/auth/AuthContext";

interface UserMenuProps {
  user: { displayName?: string; username: string };
}

export function UserMenu({ user }: UserMenuProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    handleClose();
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const displayName = user.displayName ?? user.username;

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          color: theme.palette.text.primary,
          fontWeight: 600,
          gap: 0.5,
          "&:hover": {
            color: theme.palette.info.main,
          },
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: "1rem" }}>{displayName}</Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: "1.2rem",
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            background: theme.palette.background.paper,
            border: "1px solid rgba(255, 255, 255, 0.1)",
            minWidth: 180,
          },
        }}
      >
        <MenuItem onClick={() => handleNavigate("/match")}>
          <ListItemIcon>
            <SportsEsportsIcon sx={{ color: theme.palette.text.secondary }} />
          </ListItemIcon>
          <ListItemText primary="Matches" />
        </MenuItem>
        <MenuItem onClick={() => handleNavigate("/welcome")}>
          <ListItemIcon>
            <PersonIcon sx={{ color: theme.palette.text.secondary }} />
          </ListItemIcon>
          <ListItemText primary="Profile" />
        </MenuItem>
        <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.1)" }} />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon sx={{ color: theme.palette.text.secondary }} />
          </ListItemIcon>
          <ListItemText primary="Log out" />
        </MenuItem>
      </Menu>
    </>
  );
}
